/**
 * Местное время абонента.
 *
 * Считается от UTC, а не от часов браузера: диспетчер может сидеть в любом
 * поясе, и приводить чужое время к своему — ровно та ошибка, которую эти
 * функции должны убрать. Неизвестный пояс везде считается Москвой (UTC+3) —
 * то же правило, что у окна звонка на сервере (calling.unknown_tz_as_msk).
 */

/** Пояс Москвы в минутах — фолбэк для номеров, чей пояс реестр не знает. */
export const MSK_OFFSET_MIN = 180;

export function localTimeOf(tzOffsetMin: number | null): string {
  const shifted = new Date(Date.now() + (tzOffsetMin ?? MSK_OFFSET_MIN) * 60_000);
  const hh = String(shifted.getUTCHours()).padStart(2, '0');
  const mm = String(shifted.getUTCMinutes()).padStart(2, '0');
  return `${hh}:${mm}`;
}

/** Границы окна звонка, повторяют серверные calling.window_start/end_hour. */
export const CALL_WINDOW_START_HOUR = 8;
export const CALL_WINDOW_END_HOUR = 19;

/**
 * Вышло ли местное время абонента за окно звонка 8:00–19:00.
 *
 * Клиент настройку не получает, поэтому границы продублированы константами:
 * 09.09.2026 окно сдвинули на 8:00, а красная подсветка «поздно» осталась от
 * девяти и красила рабочие номера. Набор всё равно решает сервер.
 */
export function outsideCallWindow(tzOffsetMin: number | null): boolean {
  const shifted = new Date(Date.now() + (tzOffsetMin ?? MSK_OFFSET_MIN) * 60_000);
  const hour = shifted.getUTCHours();
  return hour < CALL_WINDOW_START_HOUR || hour >= CALL_WINDOW_END_HOUR;
}

/**
 * Часов до конца окна звонка у абонента; 0 — окно уже закрылось.
 *
 * По этому числу пульт объясняет порядок карточек: восток идёт первым, потому
 * что у него вечер наступает раньше (09.09.2026).
 */
export function hoursLeftInWindow(tzOffsetMin: number | null): number {
  const shifted = new Date(Date.now() + (tzOffsetMin ?? MSK_OFFSET_MIN) * 60_000);
  return Math.max(0, CALL_WINDOW_END_HOUR - shifted.getUTCHours());
}
